// Factor chain (系数链) and the default factor constant.
//
// Per docs/DATA_SCHEMA.md §6. Every factor must appear in the chain even
// when it does not apply — in that case the value is 1 and CLAUDE.md §5
// requires that the field still be displayed.

export interface FactorChain {
  itemId: string;
  marketPrice: number;
  buildingTypeFactor: number;
  landTermFactor: number;
  propertyConditionFactor: number;
  affordableHousingFactor: number;
  industryOrientationFactor: number;
  industryProjectTypeFactor: number;
  commercialFloorFactor: number;
  undergroundSpaceFactor: number;
  projectFactor: number;
  finalFactor: number;
  notes: string[];
}

export const DEFAULT_FACTOR = 1;
